<template>
  <div class="main">
    <main>
      <div class="wrapper">
        <div class="common">
          <p>欢迎您使用爱艺术+平台及相关服务！</p>
          <p>爱艺术+平台及相关服务，是指浙江艺高文化创意有限公司及其关联方（以下简称“艺高公司”）合法拥有并运营的、标注名称为“爱艺术+”和/或“iartschool”的APP、微信公众号等客户端应用程序（同时含其定制版等不同版本）以及相关网站向用户提供的产品与服务。《爱艺术+用户服务协议》（以下简称“本协议”）是您与艺高公司就您下载、安装、注册、登录、使用、访问（以下统称“使用”）爱艺术+平台并获得爱艺术+平台提供的相关服务所订立的协议。</p>
        </div>
        <div class="common">
          <h4 class="title">一、重要提示</h4>
          <p>请您（以下亦称“用户”）在使用爱艺术+平台服务或申请注册流程时仔细阅读本协议之全部条款，并确认您已完全理解本协议之规定，特别是免除或者限制责任的条款、法律适用和争议解决条款。如您未满18周岁，请您在法定监护人陪同下仔细阅读并充分理解份协议，并征得法定监护人的同意后使用爱艺术+平台及相关服务。如您对协议有任何疑问，请立即停止使用爱艺术+平台服务及注册平台用户，并可向平台客服咨询。</p>
        </div>
        <div class="common">
          <h4 class="title">二、协议的接受与变更</h4>
          <p>请您在使用爱艺术+平台服务或注册前充分阅读并且理解本协议，当您开始使用爱艺术+平台服务或注册用户的，将视为您签署了本协议，表明您自愿接受本协议全部条款的约束，本协议将构成您与艺高公司及其经营的爱艺术+平台之间具有约束力的法律文件。</p>
          <p>考虑到互联网服务不断高速发展和演进，您同意艺高公司有权利单方对本协议进行修改，协议修改后，艺高公司将通过在相关页面公布修改的内容、通过您注册时提供的通讯工具发送或者其他任何合理方式通知您，您同意承担及时阅读确认修改协议的义务。如果您不同意协议的修改，请立即停止访问或使用爱艺术+平台或取消已经获得的服务；如果您选择在本协议修改后继续访问或使用爱艺术+平台，则视为您已接受本协议的修改。</p>
          <p>您与艺高公司签署的本协议所列明的条款，并不能完全涵盖您与艺高公司所有的权利和义务。您同意艺高公司公布其他声明、规则等均视为本协议之补充协议，为本协议不可分割的组成部分，与本协议具有同等法律效力。</p>
        </div>
        <div class="common">
          <h4 class="title">三、服务的内容与方式</h4>
          <p>您知晓并同意接受，艺高公司有权根据爱艺术+平台及相关服务或运营需要单方决定、安排或指定其关联方、控制公司、继承公司或其认可的第三方公司，为广大用户提供技术服务、推广服务等多方面的服务以及本协议项下涉及的某些服务。您同意接受相关权利义务关系亦受本协议约束。</p>
          <p>由于互联网的高速发展，艺高公司将在未来向用户提供更多的服务，除非另有明确规定外，未来提供的新服务也适用于本协议。</p>
          <p>爱艺术+平台提供服务的方式主要为：搭建“爱艺术+”网站、“爱艺术+”移动客户端、“爱艺术+老师版客户端”、及“爱艺术+”微信公众号等，为用户提供网络艺术教育课程服务及在线真人艺术教育支持服务。爱艺术+平台通过撮合有艺术学习需求的学生用户以及有教学经验的艺术家，实现二者实时语音、同屏互动的一对一在线直播课程服务以及未来技术发展出现的新的服务形态。</p>
          <p>爱艺术+平台不保证其提供的服务一定满足用户的全部需求。艺高公司保留随时修改、中断或终止无偿提供的服务且无需通知用户的权利，且不承担任何责任；若影响您与艺高公司进行的有偿交易，您同意艺高公司有权在事先通知的情况下予以修改、中断，双方将按照公平公正、诚实信用、等价有偿的原则处理后续事宜。</p>
        </div>
        <div class="common">
          <h4 class="title">四、账户的取得、使用及注销</h4>
          <p>请您确认，在您开始注册爱艺术+平台用户前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。</p>
          <p>您有权选择是否成为平台注册用户。若您阅读本协议，并完成注册，视为您同意艺高公司按本协议及个人信息政策收集、使用您的相关信息。</p>

          <p>您选择注册账号成为平台用户时，应按照平台的提示及要求填写或提供资料、信息，并确保资料、信息的真实性、正确性及完整性。如果您的资料、信息发生变化，应及时更改。</p>
          <p>当您一旦注册成功，即成为平台注册用户。成为平台注册用户，您可自行创建、修改昵称。用户名和昵称的命名及使用应遵守相关法律法规并符合网络道德。用户名和昵称中不能含有任何侮辱、诽谤、淫秽或暴力等侵害他人合法权益或违反公序良俗的词语。如您违反前述规定，艺高公司有权随时限制或拒绝您使用该账号，甚至注销该账号。</p>
          <p>a)用户注册成功时，您将创建一个账号和密码。您应采取合理措施维护账号和密码的安全，因用户原因导致账号或密码泄露而造成的法律后果由用户负责。用户对由此用户名和密码登入系统后所发生的所有活动和事件负责，并承担由此产生的直接或者间接法律责任，艺高公司不承担任何责任。</p>
          <p>b)用户的账号或密码遗失的，可以通过注册信息进行重置密码，以手机号码注册的用户可以凭借手机号码找回原密码。用户若发现账号遭到未授权的使用或存在其他安全漏洞的情况，应立即告知艺高公司。</p>
          <p>您有权注销您的账户，当您需要注销账户时，请您联系平台客服帮您处理。请您知悉，您的账户一旦被注销后将造成您无法继续收听您已购买的付费内容或上传内容等，您同意一切后果由您自行承担。</p>
        </div>
        <div class="common">
          <h4 class="title">五、用户的权利</h4>
          <p>用户有权在注册后获得其个人的平台账号；</p>
          <p>用户有权在注册并登陆后通过其个人的平台账号上载视频作品、图片、文字等；</p>
          <p>用户有权在注册并登陆后在线收看收听课程；</p>
          <p>用户有权在注册并登陆后，根据平台的规定，分享课程、艺术家之家、活动等并取得艺高公司给予的奖励，如积分等；</p>
          <p>用户有权在注册并登陆后，根据平台的规定，参与平台的线上或线下活动并取得艺高公司给予的奖励等；</p>
          <p>用户有权在注册并登陆后，根据平台的规定，参与平台的商业性项目，通过平台提供的增值化服务取得经济收益。</p>
          <p>用户有权在注册并登陆后，根据平台的规定，进行付费服务的购买，包括但不限于付费课程、VIP会员、其他可通过付费购买的服务等，购买后可享受相应的服务。您可以在最多五个设备（“设备”指包括但不限于计算机及移动电话、平板电脑等手持移动终端设备，下同）上使用您的注册账号，同一时间内仅可在一个设备上使用您的账号。超过上述范围使用的，艺高公司有权中止或终止对您的服务或取消VIP会员资格，您应自行承担超范围使用而导致的任何损失。同时艺高公司保留追究上述超范围使用行为人法律责任的权利。</p>
        </div>
        <div class="common">
          <h4 class="title">六、用户的义务</h4>
          <p>用户承诺并保证遵守《中华人民共和国著作权法》、《中华人民共和国商标法》、《中华人民共和国反不正当竞争法》、《中华人民共和国侵权责任法》、《中华人民共和国广告法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》及《信息网络传播权保护条例》等有关法律、法规、规章的规定。在任何情况下，艺高公司合理的认为用户有可能违反上述法律、法规、规章的规定，有权不经事先通知终止向该用户提供服务。</p>
          <p>用户承诺并保证，用户对其在平台上传的文字、图片、视频、音频、多媒体资料或其他内容拥有相应合法的权利。上述文字、图片、视频、音频、多媒体资料或其他内容，不侵犯任何第三方的肖像权、名誉权、著作权、商标权等权利；不违反用户与第三方所签订的对用户有约束力的法律文件的规定；否则，艺高公司有权对用户发布的信息依法或依据本协议进行删除或屏蔽，并有权不经事先通知终止向该用户提供服务。</p>
          <p>禁止用户从事以下行为：</p>
          <p>a)涉及危害国家安全、泄露国家秘密的；侵犯国家社会集体的和公民的合法权益的；制作、复制、发行或传播带有煽动抗拒、破坏法律、法规实施的，煽动颠覆国家政权，推翻社会主义制度的，煽动分裂国家、破坏国家统一的，煽动民族仇恨、民族歧视，破坏民族团结的，捏造或者歪曲事实，散布谣言，扰乱社会秩序的，宣扬封建迷信、淫秽、色情、赌博、暴力、凶杀、恐怖、教唆犯罪的，公然侮辱他人或者捏造事实诽谤他人的，或者进行其他恶意攻击的，损害国家机关信誉的，其他违反法律、法规的内容。</p>
          <p>b)冒充任何人或机构，或以虚伪不实的方式谎称或使人误认为与任何人或任何机构有关的。</p>
          <p>c)伪造标题或以其他方式操控识别资料，使人误认为该内容为艺高公司所传送的。</p>
          <p>d)将有关干扰、破坏或限制任何计算机软件、硬件或通讯设备功能的软件病毒或其他计算机代码、档案和程序之资料，加以上载、张贴、发送电子邮件或以其他方式传送。</p>
          <p>e)以技术方式攻击或破坏或改变平台的部分或全部、或干扰其运行；以非法方式获取或使用平台的任何软件、代码或其他技术或商业信息；禁止用户对平台运行的任何程序进行反向工程、反向编译、反向汇编或改写。</p>
          <p>f)未经许可使用平台的网站名称、公司名称、商标、商业标识、网页版式或内容、或其他由艺高公司或平台享有知识产权或权利的信息或资料；将平台以任何形式作为从事各种非法活动的场所、平台或媒介。未经艺高公司的书面授权或许可，用户不得以爱艺术+或平台的名义从事任何商业活动，也不得以任何形式将平台作为从事商业活动的场所、平台或媒介。</p>
          <p>g)未经艺高公司书面许可、另行签署协议或另行指定可供用户使用的特定商业服务外，用户不得以商业目的使用平台；不对平台的任何部分或全部进行商业性质利用、复制、拷贝、出售、调查、广告。</p>
          <p>h)未经艺高公司书面许可、另行签署协议或另行指定可供用户使用的特定商业服务外，用户不得通过平台发布有关任意第三方的广告宣传内容。</p>
          <p>用户就其所上传的内容承担全部法律责任。因用户违反法律规定或本协议规定造成违约或侵犯第三方合法权益的，由用户自行解决。如果给艺高公司或平台造成损失，艺高公司有权向用户追偿其因此所遭受的全部损失、包括其直接损失、间接损失、预期利益损失等损失。</p>
        </div>
        <div class="common">
          <h4 class="title">七、用户产生的内容</h4>
          <p>用户在平台以各种形式发布的一切信息，均应符合国家法律法规等相关规定及网站相关规定，符合社会公序良俗，并不侵犯任何第三方主体的合法权益。艺高公司有权随时检查您所上传的内容，如果发现您上传的内容不符合前述规定，艺高公司有权删除或重新编辑您所上传的内容。</p>
          <p>艺高公司有权对用户上传的内容进行检查、编辑与修改。但是对于通过平台而传播的内容，艺高公司不保证其合法性、正当性、准确性或完整性。在任何情况下，艺高公司均不对任何内容承担任何责任，包括但不限于由于任何内容而导致直接或间接损失。用户应自行承担因此产生的一切法律后果，且平台及艺高公司因此受到的损失，有权向用户追偿。</p>
          <p>平台将尽可能保存用户上传的合法内容，但不承诺将为用户保存其上传的内容，用户应自行就前述内容备份。</p>
        </div>
        <div class="common">
          <h4 class="title">八、用户信息保护</h4>
          <p>艺高公司对保护用户个人信息高度重视，艺高公司将会采取合理的措施保护用户的个人信息。除法律法规规定的情形外，未经用户许可艺高公司不会向第三方公开、透露用户个人信息。艺高公司对相关信息采用专业加密存储与传输方式，保障用户个人信息的安全，并将运用各种安全技术和程序建立完善的管理制度来保护你的个人信息，以免遭受未经授权的访问、使用或披露。</p>
          <p>用户注册并获得平台提供的服务时，用户须提供必要的个人信息。如：为向您提供帐号注册服务或进行用户身份识别，需要您填写手机号码；为向您提供更换头像/ 更换专辑封面/ 发布动态可选择拍照方式，需要调用摄像头的权限；为向您提供录音，并将录音作品上传的服务，需要调用录音的权限；为向您提供在播放过程中，如有电话呼入，需要切换播放状态，将正在播放的内容暂停的服务，需要获取电话状态的权限；为向您提供同步播放列表及内容的服务，需要读取您的设备账号，获得系统账号，用于和其他移动设备（例如智能手表）同步播放列表及内容的权限；为向您提供通过手机通讯录匹配功能推荐好友等服务，需要获得访问您手机通讯录的权限等。若国家法律法规或政策有特殊规定的，你需要提供真实的身份信息。若你提供的信息不完整，则无法使用本服务或在使用过程中受到限制。</p>
          <p>艺高公司承诺，未经用户同意，不会以非法方式披露用户个人信息。但是下列情形除外：依照法律或司法、行政机关的强制性命令对第三方披露用户个人信息且无需事先向用户发出通知。</p>
          <p>当用户通过平台购买商品或服务时，用户的信息将被提供给前述商品或服务的销售者，用户应自行承担此类信息披露的责任。</p>
          <p>下述情况下，用户授权艺高公司及平台利用用户的个人信息：</p>
          <p>a)在紧急情况下，为维护用户及公众的权益。</p>
          <p>b)为维护平台及艺高公司的著作权、商标权、专利权及其他任何合法权利或权益。</p>
          <p>c)在进行促销或抽奖时，平台可能会与赞助商共享用户的个人信息，在这些情况下平台会在发送用户信息之前进行提示，并且用户可以通过明确表示不参与活动而终止传送。</p>
          <p>d)为获取第三方数据而将用户信息与第三方数据匹配。</p>
          <p>e)将用户数据用于统计，以便向未来的合作伙伴、广告商及其他第三方以及为了其他合法目的而描述平台的服务。</p>
          <p>一般情况下，你可随时浏览、修改自己提交的信息，但出于安全性和身份识别（如号码申诉服务）的考虑，你可能无法修改注册时提供的初始注册信息及其他验证信息。</p>
          <p>艺高公司亦非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用平台的服务前，应事先取得您的家长或法定监护人的同意。</p>
          <p>其他事宜请您确认个人信息保护政策中的相关条款。</p>
        </div>
        <div class="common">
          <h4 class="title">九、知识产权归属与授权</h4>
          <p>艺高公司在爱艺术+平台及相关服务中提供的内容（包括但不限于软件、技术、程序、网页、文字、图片、图像、音频、视频、图表、版面设计、电子文档等）的知识产权属于艺高公司所有。艺高公司提供爱艺术+平台及相关服务时所依托的软件、网页、程序的著作权、专利权及其他知识产权均归艺高公司所有。未经艺高公司事先书面许可，任何人不得擅自使用（包括但不限于通过任何机器人、“蜘蛛”等程序或设备监视、复制、传播、展示、镜像、上载、下载）爱艺术+平台及相关服务中的内容。</p>
          <p>艺高公司为爱艺术+平台开发、运营提供技术支持，并对爱艺术+平台及相关服务的开发和运营等过程中产生的所有数据和信息等享有法律法规允许范围内的全部权利。</p>
          <p>经由本网站传送的文字、图片、音频、视频及其他内容，受到著作权法、商标法、专利法或其他法律的保护；除该文字、图片、音频、视频及其他内容的上载用户所享有的著作权，未经艺高公司书面授权许可，第三方不得进行修改、出租、售卖或衍生其他作品。</p>
          <p>艺高公司对其专有内容、原创内容和其他通过授权取得的独占或者独家内容享有知识产权。未经艺高公司书面许可，任何单位和个人不得私自转载、传播和提供收听服务或者有其他侵犯艺高公司知识产权的行为。否则，将承担法律责任。</p>
          <p>除非艺高公司收到相反通知，艺高公司将用户视为其在平台上载或发布的内容的版权所有人或已获合法授权（且含转授权）。用户点击同意本协议，即表明该用户知悉、理解并同意对用户通过爱艺术+平台及相关服务上传、发布或传输的内容（包括但不限于文字、图像、音频、视频等各种形式的内容及其中包括的音乐、声音、台词、视觉设计、对话等所有组成部分），授予艺高公司及其关联方、控制公司、继承公司一项全球范围内、免费、非独家、可再许可（通过多层次）的权利（包括但不限于复制权、翻译权、汇编权、信息网络传播权、改编权及制作衍生品、表演和展示的权利等），前述权利的授权范围包括但不限于在当前或其他网站、应用程序、产品或终端设备等使用，艺高公司及其关联方、控制公司、继承公司有权通过爱艺术+网 (www.iartschool.com) 、“爱艺术+ ”移动客户端、爱艺术+老师版客户端及爱艺术+开放API/SDK 平台等平台对前述内容进行使用、复制、下载、汇编、改编、修改、展示、传播、再许可、翻译、创建衍生作品、出版、表演等。前述授予的权利包括使用、复制和展示用户拥有或被许可使用并植入内容中的个人形象、肖像、姓名、商标、服务标志、品牌、名称、标识和公司标记（如有）以及任何其他品牌、营销或推广资产、物料、素材等的权利和许可。</p>
          <p>您确认并同意许可艺高公司以自己的名义或委托专业第三方对侵犯您上传发布的享有知识产权的内容进行代维权，维权形式包括但不限于：监测侵权行为、发送维权函、提起诉讼或仲裁、调解、和解等，公司有权对维权事宜独立作出决策并独立实施。本协议已经构成《著作权法》第二十五条所规定的书面协议，其效力及于用户在平台发布的任何受著作权法保护的内容，无论该内容形成于本协议签订前还是本协议签订后。</p>
        </div>
        <div class="common">
          <h4 class="title">十、免责说明</h4>
          <p>艺高公司作为网络服务提供者，不担保网站平台上的信息及服务能充分满足用户的需求。用户在接受平台服务的过程中，可能遇到错误、侮辱、诽谤、不作为、淫秽、色情或亵渎事件，艺高公司不承担法律责任。</p>
          <p>基于互联网的特殊性，平台也不担保服务不会中断，对服务的及时性、安全性不作担保，不承担非因平台导致的责任。艺高公司力图使用户能对本网站进行安全访问和使用，但艺高公司不保证本平台或服务器是不含病毒或其它潜在有害因素的；因此用户应使用业界公认的软件查杀任何自平台下载文件中的病毒。</p>
          <p>除非艺高公司以书面形式明确约定，艺高公司对于用户以任何方式（包括但不限于包含、经由、连接或下载）从本网站所获得的任何内容信息，包括但不限于视频内容、音频内容、广告内容、其他用户信息、商户信息、用户评价内容等，不保证其准确性、完整性、可靠性；对于用户因本网站上的内容信息而购买、获取的任何产品、服务、信息或资料，艺高公司不承担责任。</p>
          <p>平台内所有用户所上传的视频、音频、图片等内容，仅代表用户个人观点，并不表示本网站赞同其观点或证实其描述，本网站不承担用户上传的内容引发的任何法律责任。艺高公司有权删除平台内各类不符合法律或协议规定的内容，而保留不通知用户的权利，但该权利不构成公司的义务或承诺，艺高公司不能保证及时发现违法行为或进行相应处罚。</p>
          <p>所有发给用户的通告，平台都将通过正式的页面公告或站内信或电子邮件或客服电话或手机短信或常规的信件送达。任何非经平台正规渠道获得的活动或信息，艺高公司不承担法律责任。</p>
          <p>您理解并同意：关于爱艺术+平台及相关服务，艺高公司不提供任何种类的明示或暗示担保或条件，包括但不限于商业适售性、特定用途适用性等。您对爱艺术+平台及相关服务的使用行为应自行承担相应风险。</p>
          <p>在任何情况下，艺高公司均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因您使用爱艺术+平台及相关服务而遭受的利润损失，承担责任。除法律法规另有明确规定外，艺高公司对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您因使用爱艺术+平台及相关服务期间而支付给艺高公司的费用（如有）</p>
        </div>
        <div class="common">
          <h4 class="title">十一、第三方链接</h4>
          <p>艺高公司可能会提供第三方国际互联网网站或资源链接，除非另有声明外，艺高公司无法对第三方网站服务进行控制，因此由于下载、传播、使用或依赖第三方网站或资源所产生的争议、损失或损害，由您自行与第三方解决，艺高公司不承担任何责任。</p>
        </div>
        <div class="common">
          <h4 class="title">十二、侵权投诉</h4>
          <p>根据《中华人民共和国侵权责任法》的规定，任何第三方认为，用户利用爱艺术+平台侵害其民事权益或实施侵权行为的，被侵权人有权书面通知艺高公司采取删除、屏蔽、断开链接等必要措施。</p>
          <p>根据《信息网络传播权保护条例》的规定，任何第三方认为，平台所涉及的作品、表演、录音录像制品，侵犯自己的合法权益的，可以向平台提交书面通知，要求平台删除该侵权作品，或者断开链接。通知书应当包含下列内容：权利人的姓名（名称）、联系方式和地址；要求删除或者断开链接的侵权作品、表演、录音录像制品的名称和网络地址；权利人的有效权利证明材料。权利人应当对通知书的真实性负责，如果侵权投诉不实，则需承担相应的法律责任。</p>
          <p>侵权投诉必须包含下述信息：被侵权人的有效权利证明材料，或被侵权作品的原始链接及其它证明材料；侵权信息或作品在平台上的具体名称及链接；侵权投诉人的联络方式，以便平台及时与您取得联系，包括电子邮件地址、电话号码或手机等；投诉内容须纳入以下声明：“本人本着诚信原则，有证据认为该对象侵害本人的合法权益。本人承诺全部投诉信息真实、准确，自愿承担一切后果。”；本人亲笔签字并注明日期，如代理他人投诉的，必须出具授权人签字的授权书。</p>
        </div>
        <div class="common">
          <h4 class="title">十三、平台的商业活动</h4>
          <p>您理解并接受，艺高公司为爱艺术+平台的运营，可以进行下述商业活动：通过电子邮件、客户端、网页或其他合法方式向用户发送推广信息或其他相关商业信息。通过增值服务系统或其他方式向用户发送相关服务信息或其他信息，其他信息包括但不限于通知信息、宣传信息、广告信息等。</p>
          <p>您理解并接受，艺高公司为了爱艺术+平台的运营可在平台及相关服务中展示艺高公司、关联公司或第三方的商业、非商业信息。</p>
        </div>
        <div class="common">
          <h4 class="title">十四、服务的终止</h4>
          <p>艺高公司有权在任何时候，基于任何原因，暂时或永久地终止本网站服务之全部或部分，而无需提前通知。艺高公司对平台服务的终止对用户和任意第三人均无需承担任何责任。</p>
          <p>艺高公司有权在任何时候，基于任何原因，暂时或永久地终止用户的账号、密码使用本网站服务，或删除、转移用户存储、发布在本网站的内容，而无需提前通知，且对用户和任意第三人均无需承担任何责任。</p>
        </div>
        <div class="common">
          <h4 class="title">十五、违约处理</h4>
          <p>针对用户违反本协议或其他服务条款的行为，艺高公司有权独立判断并视情况采取预先警示、拒绝发布、立即停止传输信息、删除内容或评论、短期禁止发布内容或评论、限制帐号部分或者全部功能直至终止提供服务、永久关闭帐号等措施，对于因此而造成用户无法正常使用帐号及相关服务、无法正常获取用户帐号内资产或其他权益等后果，艺高公司不承担任何责任。艺高公司有权公告处理结果，且有权根据实际情况决定是否恢复相关帐号的使用。对涉嫌违反法律法规、涉嫌违法犯罪的行为，艺高公司将保存有关记录，并有权依法向有关主管部门报告、配合有关主管部门调查、向公安机关报案等。对已删除内容公司有权不予恢复。</p>
          <p>因用户违反本协议或其他服务条款规定，引起第三方投诉或诉讼索赔的，用户应当自行处理并承担可能因此产生的全部法律责任。因用户的违法或违约等行为导致艺高公司及其关联方、控制公司、继承公司向任何第三方赔偿或遭受国家机关处罚的，用户还应足额赔偿艺高公司及其关联方、控制公司、继承公司因此遭受的全部损失。</p>
          <p>艺高公司尊重并保护用户及他人的知识产权、名誉权、姓名权、隐私权等合法权益。您保证，在使用爱艺术+平台及相关服务时上传的文字、图片、视频、音频、链接等不侵犯任何第三方的知识产权、名誉权、姓名权、隐私权等权利及合法权益。否则，艺高公司有权在收到权利方或者相关方通知的情况下移除该涉嫌侵权内容。针对第三方提出的全部权利主张，用户应自行处理并承担可能因此产生的全部法律责任；如因用户的侵权行为导致艺高公司及其关联方、控制公司、继承公司遭受损失的（包括但不限于经济、商誉等损失），用户还应足额赔偿艺高公司及其关联方、控制公司、继承公司遭受的全部损失。</p>
        </div>
        <div class="common">
          <h4 class="title">十六、法律适用、管辖和其他</h4>
          <p>本协议签订地为中华人民共和国浙江省杭州市西湖区。</p>
          <p>本协议的生效、履行、解释及争议的解决均适用中华人民共和国法律，并且排除一切冲突法规定的适用。用户因使用艺高公司及平台而产生或与之相关的一切争议。权利主张或其他事项，均适用中华人民共和国法律，并且排除一切冲突法规定的适用。</p>
          <p>用户与艺高公司及其经营的平台发生的一切争议，应友好协商，如协商不成的，可选择按下述任一途径解决：</p>
          <p>（一） 提交杭州仲裁委员会，按照申请仲裁时现行有效的仲裁规则进行仲裁；仲裁裁决为终局裁决，对各方均有约束力；</p>
          <p>（二） 提交协议签订地人民法院诉讼管辖；</p>
          <p>平台可能不时发布针对用户的相关协议，并可能将该相关协议作为对本协议的补充或修改而将其内容作为本协议的一部分。请您及时关注并阅读相关协议。</p>
          <p>本协议任意一条被视为废止、无效或不可执行，该条款应视为可分的且不影响本协议其他条款的法律效力。</p>
          <p>【审慎提醒】 如您使用爱艺术+平台或进行用户注册的，将视为您已同意前述服务协议，该等条款将立即生效，并构成您和浙江艺高文化创意有限公司及其关联方、爱艺术+平台之间有约束力的法律文件。</p>
          <p>请您再次确认您已全部阅读并充分理解上述协议。</p>
        </div>
        <!--  <div class="common">
            <h4 class="title"></h4>
            <p></p>
        </div>-->
      </div>
    </main>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "爱艺术+用户服务协议"
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
main {
  color: #333;
  .wrapper {
    background: #fff;
    border-radius: 10px;
    padding: 16px;
  }
}
.common {
  h4 {
    font-size: 18px;
    line-height: 24px;
    font-weight: normal;
    margin-bottom: 20px;
  }
  p {
    font-size: 14px;
    line-height: 28px;
  }
}
.common:not(:last-child) {
  margin-bottom: 68px;
}
</style>